import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/img/icon/arrow-19-11.svg';
const _withScopeId = n => (_pushScopeId("data-v-246ba2a9"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "success__info-order"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_3 = [_hoisted_2];
const _hoisted_4 = {
  class: "success__data"
};
const _hoisted_5 = {
  class: "success__data-date"
};
const _hoisted_6 = {
  class: "success__data-number"
};
const _hoisted_7 = {
  class: "success__product"
};
const _hoisted_8 = ["src"];
const _hoisted_9 = {
  class: "success__info"
};
const _hoisted_10 = {
  class: "success__info-item"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "success__info-name"
}, "Кол-во", -1));
const _hoisted_12 = {
  class: "success__info-value"
};
const _hoisted_13 = {
  class: "success__info-item"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "success__info-name"
}, "Итого", -1));
const _hoisted_15 = {
  class: "success__info-value"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "грн", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_scrollbar = _resolveComponent("el-scrollbar");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: _normalizeClass(["success__arrow", {
      'success__arrow--open': $props.isVisible
    }])
  }, _hoisted_3, 2), _createElementVNode("div", _hoisted_4, [_createElementVNode("p", _hoisted_5, _toDisplayString($props.formattedDate[0]) + " " + _toDisplayString($props.year), 1), _createElementVNode("p", _hoisted_6, "# " + _toDisplayString($props.number), 1)]), _createVNode(_component_el_scrollbar, {
    class: "success__product-scrollbar"
  }, {
    default: _withCtx(() => [_createElementVNode("ul", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.items, (item, id) => {
      return _openBlock(), _createElementBlock("li", {
        class: "success__product-item",
        key: id
      }, [_createElementVNode("img", {
        class: "success__product-img",
        src: require(`@/img/products/${item.imgUrl}`),
        alt: "product"
      }, null, 8, _hoisted_8)]);
    }), 128))])]),
    _: 1
  }), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_hoisted_11, _createElementVNode("p", _hoisted_12, _toDisplayString($props.count), 1)]), _createElementVNode("div", _hoisted_13, [_hoisted_14, _createElementVNode("p", _hoisted_15, [_createTextVNode(_toDisplayString($props.totalPrice) + " ", 1), _hoisted_16])])])]);
}